function vatNumber(value: string): boolean {
  const regexVatNumber =
    /(BE)?0[0-9]{9}|(NL)?[0-9]{9}B[0-9]{2}|(LU)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}/;

  const isValueVatNumber = regexVatNumber.test(value);

  return isValueVatNumber;
}

export default vatNumber;
